module.exports = __webpack_public_path__ + "static/media/TableTopLandingScreen.bc665747.png";